import Exception from '../lang/Exception'

export default class IOException extends Exception { }